import React, { ReactNode } from 'react';

import styles from './DocumentCaptureButtons.scss';

type DocumentCaptureButtonsProps = {
  children: ReactNode;
}

const DocumentCaptureButtons = ({ children } : DocumentCaptureButtonsProps) => (
  <div className={styles.buttonsContainer} data-cy='documentCaptureButtons'>
    {children}
  </div>
);

export default DocumentCaptureButtons;
